import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import industryImg1 from "../assets/img/industry-img1.jpg";
import industryImg2 from "../assets/img/industry-img2.jpg";
import industryImg3 from "../assets/img/industry-img3.jpg";
import industryImg4 from "../assets/img/industry-img4.jpg";
import industryImg5 from "../assets/img/industry-img5.jpg";
import industryImg6 from "../assets/img/industry-img6.jpg";
import industryImg7 from "../assets/img/industry-img7.jpg";



export const Projects = () => {

    const projects = [
        {
            title: "Business Startup",
            description: "Design & Development",
            imgUrl: projImg1,
        },
        {
            title: "Business Startup",
            description: "Design & Development",
            imgUrl: projImg2,
        },
        {
            title: "Business Startup",
            description: "Design & Development",
            imgUrl: projImg3,
        },
    ];

    const projects1 = [
        {
            title: "Retail & E-commerce",
            description: "Optimizing the retail and e-commerce experience through innovative IT solutions that streamline operations and enhance online sales",
            imgUrl: industryImg1,
        },
        {
            title: "Pharmaceutical and Healthcare",
            description: "Using transformative digital solutions to drive healthcare innovation and improve patient outcomes in a rapidly evolving environment",
            imgUrl: industryImg2,
        },
        {
            title: "High Tech",
            description: "Enabling businesses to achieve success through innovative software technology solutions designed to automate processes, increase efficiency, and streamline operations.",
            imgUrl: industryImg3,
        },
    ];

    const projects2 = [
        {
            title: "Banking, Financial Services, and Insurance",
            description: "We help our clients achieve success and generate value for their shareholders at every stage of the banking and financial services value chain.",
            imgUrl: industryImg4,
        },
        {
            title: "Consulting",
            description: "Empower businesses with specialized IT consulting to leverage technology and achieve unique success",
            imgUrl: industryImg5,
        },
        {
            title: "Energy and Utilities",
            description: "Boost digital innovation, cut costs, improve satisfaction, and address environmental concerns with our IT solutions.",
            imgUrl: industryImg6,
        },
    ];

    const projects3 = [
        {
            title: "Media and Telecommunications",
            description: "Driving media and telecommunications transformation through innovative digital engineering and adaptable services for global scalability.",
            imgUrl: industryImg7,
        },
    ];






    return (
        <section className="project" id='projects'>
            <Container>
                <Row>
                    <Col>
                        <h2>Industries</h2>
                        <p>Our services address critical gaps to bring businesses’ industry-specific technological expertise in a full range of IT services and workforce solutions. We combine this modern technology, knowledge & business savviness to enhance our clients’ IT capabilities in a cost effective manner. Our unique strategy and approach will make the job done at a significantly low-cost budget.</p>
                        <Tab.Container id="projects-tabs" defaultActiveKey="first">
                            <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Tab 1</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Tab 2</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third">Tab 3</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <Row>
                                        {
                                            projects1.map((project, index) => {
                                                return (
                                                    <ProjectCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <Row>
                                        {
                                            projects2.map((project, index) => {
                                                return (
                                                    <ProjectCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                    <Row>
                                        {
                                            projects3.map((project, index) => {
                                                return (
                                                    <ProjectCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2}></img>

        </section>
    )
}

